import { Component, Inject } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IInvoiceInfo, IInvoiceInfoForm } from './../../../models/annex';
import { SnackbarType } from 'src/app/models/snackbar-type.enum';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-campo-nf',
  templateUrl: './campo-nf.component.html',
  styleUrls: ['./campo-nf.component.scss']
})
export class CampoNfComponent {
  invoice = new FormGroup<IInvoiceInfoForm>({
    InvoiceNumber: new FormControl<string>(this.data.InvoiceNumber ?? '', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    InvoiceDate: new FormControl<string>(this.data.InvoiceDate ?? '', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    BatchId: new FormControl<string>(this.data.BatchId ?? '', {
      nonNullable: true,
      validators: [Validators.required]
    })
  });

  constructor(
    public dialogRef: MatDialogRef<CampoNfComponent>,
    private _snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: IInvoiceInfo
  ) {}

  close(action: boolean): void {
    if (action) {
      if (this.invoice.controls['InvoiceNumber'].invalid) {
        this._snackbarService.openSnackBar(
          'Número da NF é obrigatório!',
          SnackbarType.Danger
        );
        return;
      }

      if (this.invoice.controls['InvoiceDate'].invalid) {
        this._snackbarService.openSnackBar(
          'Data de Emissão da NF é obrigatório!',
          SnackbarType.Danger
        );
        return;
      }

      this.dialogRef.close(this.invoice.getRawValue());
    } else {
      this.dialogRef.close(action);
    }
  }
}
